import React from 'react';
import { primaryButton, secondaryButton } from './contractLabels';

// Modal simple con formulario: título, contenido y botones Confirmar / Cancelar
const ContractModal = ({ title, children, onClose, onConfirm, confirmLabel = 'Confirmar', busy = false, error }) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900 bg-opacity-80">
        <div className="w-full max-w-lg bg-white rounded-lg shadow-lg max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between p-4 border-b">
                <h3 className="text-lg font-semibold text-blue-600">{title}</h3>
                <button type="button" onClick={onClose} className="hover:text-red-500">
                    <span className="material-icons">close</span>
                </button>
            </div>

            <form
                onSubmit={(e) => { e.preventDefault(); onConfirm(); }}
                className="flex flex-col flex-1 min-h-0"
            >
                <div className="p-4 space-y-4 overflow-y-auto">
                    {children}
                    {error && <p className="text-sm text-red-600">{error}</p>}
                </div>

                <div className="flex justify-end gap-3 p-4 border-t">
                    <button type="button" onClick={onClose} className={secondaryButton}>Cancelar</button>
                    <button type="submit" disabled={busy} className={primaryButton}>
                        {busy ? 'Guardando...' : confirmLabel}
                    </button>
                </div>
            </form>
        </div>
    </div>
);

export default ContractModal;
